import { useMutation } from "@tanstack/react-query";
import {
  EditableTextAddParams,
  editableTextAdd,
} from "common/api/unos_rad/unos_editable_text";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosEditableTextAddParams = {
  invalidateKeys?: string[];
};

export const useUnosEditableTextAdd = (
  hookParams?: UseUnosEditableTextAddParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: editableTextAddMutate } = useMutation({
    mutationFn: async (editableTextAddParams: EditableTextAddParams) =>
      await editableTextAdd(editableTextAddParams),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { editableTextAddMutate };
};
